
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 54 54"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 9717","d":"M27 0A27 27 0 110 27 27 27 0 0127 0z","fill":"#1d213c"}}),_c('path',{attrs:{"data-name":"Path 26011","d":"M17.794 32.381a.31.31 0 00.31.31h1.5a.321.321 0 00.31-.31V28.22h1.81l2.173 4.324a.28.28 0 00.261.147h1.713a.309.309 0 00.277-.473l-2.235-4.149a3.6 3.6 0 002.411-3.292 3.534 3.534 0 00-3.553-3.508h-4.667a.31.31 0 00-.31.31zm2.138-5.907v-3.247h2.66a1.623 1.623 0 011.615 1.583 1.662 1.662 0 01-1.616 1.664zm9.545 5.907a.31.31 0 00.31.31h1.5a.321.321 0 00.31-.31v-3.835h2.04a3.67 3.67 0 003.639-3.671 3.649 3.649 0 00-3.652-3.606h-3.837a.31.31 0 00-.31.31zm2.121-5.825v-3.28h1.893a1.628 1.628 0 011.681 1.583 1.682 1.682 0 01-1.681 1.7z","fill":"#fff","stroke":"rgba(0,0,0,0)"}}),_c('g',{attrs:{"data-name":"Ellipse 250","transform":"translate(10.663 10.663)","fill":"none","stroke":"#fff","stroke-width":".5"}},[_c('circle',{attrs:{"cx":"16.317","cy":"16.317","r":"16.317","stroke":"none"}}),_c('circle',{attrs:{"cx":"16.317","cy":"16.317","r":"16.067"}})]),_c('g',{attrs:{"data-name":"Ellipse 251","fill":"none","stroke":"#fff","transform":"translate(7.4 7.4)"}},[_c('circle',{attrs:{"cx":"19.581","cy":"19.581","r":"19.581","stroke":"none"}}),_c('circle',{attrs:{"cx":"19.581","cy":"19.581","r":"19.081"}})])])
          )
        }
      }
    